import { TableFilterTypes } from '@ge/models/constants';

export const AnomalyTaskColumns = {
  GROUP_PRIORITY: 'group-priority',
  PRIORITY: 'priority',

  GROUP_DESCRIPTION: 'group-description',
  DESCRIPTION: 'description',

  GROUP_CREATE_DATE: 'group-createDate',
  CREATE_DATE: 'createDate',

  GROUP_CLOSED: 'group-closed',
  CLOSED: 'closed',

  GROUP_ID: 'group-id',
  ID: 'id',
};

// Define all available columns in the Anomaly cases table.
export const AnomalyTaskColumnDefs = {
  [AnomalyTaskColumns.GROUP_PRIORITY]: {
    cols: {
      [AnomalyTaskColumns.PRIORITY]: {
        labels: [
          {
            a11yKey: 'anomalyCaseHistory.priority',
            a11yDefault: 'Priority',
            sortValue: 'priority',
          },
        ],
        cell: {
          align: 'center',
          maxWidth: '10%',
          width: '10%',
          noPadding: true,
        },
        filterType: TableFilterTypes.CHECKBOXES,
        enableShowAll: true,
      },
    },
  },
  [AnomalyTaskColumns.GROUP_DESCRIPTION]: {
    cols: {
      [AnomalyTaskColumns.DESCRIPTION]: {
        labels: [
          {
            a11yKey: 'anomalyCaseHistory.description',
            a11yDefault: 'Title',
            sortValue: 'description',
          },
        ],
        cell: {
          align: 'left',
          maxWidth: '45%',
          width: '45%',
          noPadding: true,
        },
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [AnomalyTaskColumns.GROUP_CREATE_DATE]: {
    cols: {
      [AnomalyTaskColumns.CREATE_DATE]: {
        labels: [
          {
            a11yKey: 'createDate',
            a11yDefault: 'Created Date',
            sortValue: 'createDate',
          },
        ],
        cell: {
          align: 'center',
          maxWidth: '15%',
          width: '15%',
          noPadding: true,
        },
        filterType: TableFilterTypes.DATE,
      },
    },
  },
  [AnomalyTaskColumns.GROUP_CLOSED]: {
    cols: {
      [AnomalyTaskColumns.CLOSED]: {
        labels: [
          {
            a11yKey: 'closed',
            a11yDefault: 'Completed Date',
            sortValue: 'closed',
          },
        ],
        cell: {
          align: 'center',
          maxWidth: '15%',
          width: '15%',
          noPadding: true,
        },
        filterType: TableFilterTypes.DATE,
      },
    },
  },
  [AnomalyTaskColumns.GROUP_ID]: {
    cols: {
      [AnomalyTaskColumns.ID]: {
        labels: [
          {
            a11yKey: 'anomalyCaseHistory.id',
            a11yDefault: 'Case Detail',
          },
        ],
        cell: {
          align: 'center',
          maxWidth: '15%',
          width: '15%',
          noPadding: true,
        },
      },
    },
  },
};

export const defaultAnomalyTasksCols = [
  {
    id: AnomalyTaskColumns.GROUP_PRIORITY,
    cols: [
      {
        id: AnomalyTaskColumns.PRIORITY,
        visible: true,
      },
    ],
  },
  {
    id: AnomalyTaskColumns.GROUP_DESCRIPTION,
    cols: [
      {
        id: AnomalyTaskColumns.DESCRIPTION,
        visible: true,
      },
    ],
  },
  {
    id: AnomalyTaskColumns.GROUP_CREATE_DATE,
    cols: [
      {
        id: AnomalyTaskColumns.CREATE_DATE,
        visible: true,
      },
    ],
  },
  {
    id: AnomalyTaskColumns.GROUP_CLOSED,
    cols: [
      {
        id: AnomalyTaskColumns.CLOSED,
        visible: true,
      },
    ],
  },
  {
    id: AnomalyTaskColumns.GROUP_ID,
    cols: [
      {
        id: AnomalyTaskColumns.ID,
        visible: true,
      },
    ],
  },
];
